import React, {Component} from 'react'
import "./quantityCard.css"

/**
 * 数量统计看片组件
 */
class QuantityCard extends  Component{
    constructor(props){
        super(props);
        this.state={image:props.image}

    }



    render() {
        let stylet = {
            // backgroundImage:'url('+this.state.image+')',
            position: "relative",
            backgroundRepeat: "no-repeat",
            backgroundSize:"contain",
            padding:"0"
        }
        return (
            <div className='cardContainer' style={stylet}>
                <img src={this.state.image} style={{position:"absolute",top:"0px",left:"0px",width:"100%",height:"100%",zIndex:"0"}} />
                <div style={{position:"absolute",top:"30px",left:"90px"}}>
                    <div className='quercardTitle'><b>{this.props.cardTitle}</b></div>
                    <div className='dataNumber'><b>{this.props.number}</b></div>
                </div>
            </div>
        )
    }
}

export default QuantityCard;